import { render, staticRenderFns } from "./OrderReport.vue?vue&type=template&id=5ff8262c&scoped=true"
import script from "./OrderReport.vue?vue&type=script&lang=js"
export * from "./OrderReport.vue?vue&type=script&lang=js"
import style0 from "./OrderReport.vue?vue&type=style&index=0&id=5ff8262c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff8262c",
  null
  
)

export default component.exports